module.exports = __webpack_public_path__ + "static/media/driver.0f6826db.png";